import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { ICO2Bottle } from '../../models/co2-bottle';
import { dbConst } from './databaseConstants';
import { FirestoreCrudService } from './crudService';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class Co2BottleService {

  private crudService: FirestoreCrudService<ICO2Bottle>;

  constructor(
    firestore: Firestore,
    authService: AuthService) {
    this.crudService = new FirestoreCrudService<ICO2Bottle>(firestore, authService, dbConst.co2Bottles);
  }

  getNewId(): string {
    return this.crudService.getNewId();
  }

  async add(item: ICO2Bottle, id: string | undefined = undefined) {
    return await this.crudService.add(item, id);
  }

  async update(item: ICO2Bottle) {
    const updateItem = { ...item };
    updateItem.locationId = updateItem.locationId ? updateItem.locationId : null;
    updateItem.plaato2Id = updateItem.plaato2Id ? updateItem.plaato2Id : null;
    updateItem.towerId = updateItem.towerId ? updateItem.towerId : null;
    return await this.crudService.update(updateItem);
  }

  async softUpdate(id: string, item: any, uid: string) {
    return await this.crudService.softUpdate(id, item, uid);
  }

  async delete(id: string): Promise<void> {
    return await this.crudService.delete(id);
  }

  getItem(id: string) {
    return this.crudService.get(id);
  }

  getItemOnce(id: string) {
    return this.crudService.getOnce(id);
  }

  getItems(barId: string) {
    return this.crudService.getItemsOrderBy(barId, 'name', undefined);
  }
}
